import { createContext, useContext, useState } from "react";

const DnDContext = createContext([null, (_:any) => {}]);

export const DnDProvider = ({ children }: any) => {



  const [dndNode, setDndNode] = useState(null);

  return (
    <DnDContext.Provider value={[dndNode, setDndNode]}>
      {children}
    </DnDContext.Provider>
  );
};

export const useDnD = () => {
    return useContext(DnDContext);
  }

export default DnDContext;
